import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import { AppStandardButton } from "../components/UI/AppButtons";
import React from "react";

export default function AlertMessage({
  openModal,
  className = "",
  requestOnClose,
  modalMessage,
  isTermsConditionPopUp,
}) {
  const isDesktopScreen = window.innerWidth >= 1220;
  return (
    <Dialog
      className={className}
      open={openModal}
      onClose={requestOnClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={
        isTermsConditionPopUp
          ? {
              style: {
                borderRadius: "10px",
                minWidth: "370px",
                position: "absolute",
                top: isDesktopScreen ? "70%" : "50%",
                left: isDesktopScreen ? "50%" : "42%",
                transform: "translate(-50%, -50%)",
              },
            }
          : { style: { borderRadius: "10px", minWidth: "370px" } }
      }
    >
      <DialogTitle
        style={{ padding: "1rem", fontFamily: "MBCorpoSText-Regular-Web-new" }}
      >
        {modalMessage}
      </DialogTitle>

      <DialogActions
        sx={{
          justifyContent: "center",
        }}
      >
        <AppStandardButton variant="outlined" onClick={requestOnClose}>
          <p className="text-black normal-case">Close</p>
        </AppStandardButton>
      </DialogActions>
    </Dialog>
  );
}
